import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../utils/fetchers";
import { getAdminAccessToken } from "../../utils/auth";

export const useContactInfoByAdmin = () => {
  const token = getAdminAccessToken();
  return useQuery({
    queryKey: ["contact-info-by-admin"],
    queryFn: () =>
      fetcher<{
        phoneNumber: string;
        email: string;
        country: string;
      }>(`system-setting`, token),
  });
};
